import Configs from '../../../../vendor_core/src/vendorConfigs/Configs';
import IAuthorizationData from '../../../../vendor_core/core/src/server/data/IAuthorizationData';
import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';

export default class VOEConfigDataParser implements IBaseDataParser<IAuthorizationData> {
    public check(data: any): boolean {
        return data && data.config;
    }

    public parse(data: any): IAuthorizationData[] {
        Configs.game.parseRTP(data.config.rtp);
        let rtp = Configs.game.getRTP();
        const result: IAuthorizationData = {
            rtp: rtp
        };

        return [result];
    }
}
